import { render, staticRenderFns } from "./HKLTable.vue?vue&type=template&id=3ed1a216&scoped=true&"
import script from "./HKLTable.vue?vue&type=script&lang=js&"
export * from "./HKLTable.vue?vue&type=script&lang=js&"
import style0 from "./HKLTable.vue?vue&type=style&index=0&id=3ed1a216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1a216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed1a216')) {
      api.createRecord('3ed1a216', component.options)
    } else {
      api.reload('3ed1a216', component.options)
    }
    module.hot.accept("./HKLTable.vue?vue&type=template&id=3ed1a216&scoped=true&", function () {
      api.rerender('3ed1a216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Table/HKLTable.vue"
export default component.exports